import { useState } from "react";

export type DrawerBottomAreaProps = {
    displayName?: string;
    planName?: string;
    avatarUrl?: string;
    onSettings: () => void;
    onBilling: () => void;
    onNotifications: () => void;
    onDocs: () => void;
    onLogout: () => void | Promise<void>;
    onCloseDrawer: () => void;
    onOpenUrgent: () => void;
};

export type DrawerBottomAreaHookProps = Omit<
    DrawerBottomAreaProps,
    "displayName" | "avatarUrl" | "planName"
>;

export const useDrawerBottomArea = ({
    onSettings,
    onBilling,
    onNotifications,
    onDocs,
    onLogout,
    onCloseDrawer,
    onOpenUrgent,
}: DrawerBottomAreaHookProps) => {
    const [talkToChrisOpen, setTalkToChrisOpen] = useState(false);

    const handleSettingsClick = () => {
        onSettings();
    };

    const handleBillingClick = () => {
        onBilling();
    };

    const handleTalkToChrisClick = () => {
        setTalkToChrisOpen(true);
    };

    const handleNotificationsClick = () => {
        onNotifications();
    };

    const handleDocsClick = () => {
        onDocs();
    };

    const handleLogoutClick = async () => {
        await onLogout();
    };

    const handleTalkToChrisOpenChange = (value: boolean) => {
        setTalkToChrisOpen(value);
    };

    const openUrgentFromTalk = () => {
        onOpenUrgent();
        setTalkToChrisOpen(false);
        onCloseDrawer();
    };

    return {
        talkToChrisOpen,
        handleSettingsClick,
        handleBillingClick,
        handleTalkToChrisClick,
        handleNotificationsClick,
        handleDocsClick,
        handleLogoutClick,
        handleTalkToChrisOpenChange,
        openUrgentFromTalk,
    };
};
